var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Price Limits" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "METRC Price Limits", "with-footer": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            [
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canUpdatePriceLimits } },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        disabled: !_vm.canUpdatePriceLimits,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.savePriceLimits.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Save Price Limits\n                "
                                      ),
                                      _vm.formState.processing
                                        ? _c("b-spinner", {
                                            staticClass: "ml-1",
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      fields: _vm.tableFields,
                      items: _vm.priceLimits,
                      "table-class": "text-nowrap",
                      responsive: "",
                      hover: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(unit_type)",
                        fn: function (data) {
                          return [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.unitTypesOptions,
                                disabled: !_vm.canUpdatePriceLimits,
                              },
                              model: {
                                value: _vm.priceLimits[data.index].unit_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.priceLimits[data.index],
                                    "unit_type",
                                    $$v
                                  )
                                },
                                expression: "priceLimits[data.index].unit_type",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(min_price)",
                        fn: function (data) {
                          return [
                            _c("b-form-input", {
                              attrs: {
                                type: "number",
                                disabled: !_vm.canUpdatePriceLimits,
                              },
                              model: {
                                value: _vm.priceLimits[data.index].min_price,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.priceLimits[data.index],
                                    "min_price",
                                    $$v
                                  )
                                },
                                expression: "priceLimits[data.index].min_price",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(max_price)",
                        fn: function (data) {
                          return [
                            _c("b-form-input", {
                              attrs: {
                                type: "number",
                                disabled: !_vm.canUpdatePriceLimits,
                              },
                              model: {
                                value: _vm.priceLimits[data.index].max_price,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.priceLimits[data.index],
                                    "max_price",
                                    $$v
                                  )
                                },
                                expression: "priceLimits[data.index].max_price",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }